import { QueryClient } from '@tanstack/react-query';

// One client per app mount: on the server that means one per request, so
// SSR pages never share (or leak) cached data between visitors.
export const createQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: false,
      },
    },
  });
